import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useAuth } from "../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormHelperText from "@mui/material/FormHelperText";
import CloseIcon from "@mui/icons-material/Close";

import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
function BooksFeeList() {
  const { oId, userId, role,board ,pId} = useAuth();
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  console.log("Filtered Data:", filteredData);

  // const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [errors, setErrors] = useState({});

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);


// const [classSectionData, setClassSectionData] = useState([]);
// const [classOptions, setClassOptions] = useState([]);
// const [sectionOptions, setSectionOptions] = useState([]);

const [sscClassSectionData, setSscClassSectionData] = useState([]);
const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState("");
// const [sscSelectedSection, setSscSelectedSection] = useState("");
const [sscSelectedSection, setSscSelectedSection] = useState("");

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
// const [interSelectedClass, setInterSelectedClass] = useState("");
// const [interSelectedSection, setInterSelectedSection] = useState('');
const [interSelectedClass, setInterSelectedClass] = useState("");
const [interSelectedSection, setInterSelectedSection] = useState("");
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");

const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
console.log("selected mode :"+mode);
const [sscClassSectionMap, setSscClassSectionMap] = useState({});
const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag



  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

  const [editedData, setEditedData] = useState({
    grandTotal: "",
    // totalPaid: "",
    feeDue: "",
    payMethod: "",
    paymentDate: "",
    transactionId: "",
    paymentAmount: "",
  });

  const handleAddNew = () => {
    navigate("/BusFeeRegistrationForm");
  };


    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data);
        if (data.length > 0) {
          setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
   useEffect(() => {
     if (isPrincipal) {
       fetchUsers();
     }
   }, []); // ✅ Only runs on mount 







//Ad,ission fee amount dialog states and api
    const [open, setOpen] = useState(false);
  const [romanNumberClass, setRomanNumberClass] = useState("");
   const [dialogcourse, setDialogCourse] = useState("");
  const [examFee, setExamFee] = useState("");
  const [examloading, setExamLoading] = useState(false);

// const handleSubmit = async () => {
//   if (!romanNumberClass) {
//     toast.error("Please select class");
//     return;
//   }

//   if (!examFee) {
//     toast.error("Please enter amount.");
//     return;
//   }

//   setExamLoading(true);
//   try {
//     const response = await fetch(
//       `${baseUrl}/api/admission/updateAdmissionFeeByClassYear/${oId}/${pId}?romanNumberClass=${romanNumberClass}&course=${dialogcourse}&newAdmissionFee=${examFee}`,
//       {        
//         method: "PATCH"
//       }
//     );

//     const msg = await response.text(); // await the response message

//     if (!response.ok) {
//       toast.error(msg || "Failed to assign Admission fee");
//     } else {
//       toast.success(msg || "Admission fee assigned successfully!");
//       setOpen(false);
//       setRomanNumberClass("");
//       setExamFee("");
//       // fetchGetAllTableData();
//       fetchClassSectionTableData();
//     }
//   } catch (error) {
//     toast.error(`Error: ${error.message}`);
//   } finally {
//     setExamLoading(false);
//   }
// };











//fetch table scrolling data
  // const fetchGetAllTableData = async () => {
  //   if(!UserId) return;
  //   setTableLoading(true);
  //   setHasFetchedOnce(false);
  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/api/feePayment/adm/getAllStudentsfeePayments/${oId}/${UserId}?rolePayment=admission_fee`
  //     );             
  //     const data = await response.json();
  //     if (response.ok) {
  //      setFilteredData(data.feePayments || []);
      
  //       // setUniqueCourseType([...new Set(data.map(item => item.course))]);
  //     } else {
  //     setFilteredData([]);
  //     }
  
  //   } catch (error) {
  //     console.error("Error fetching  table data:", error);
  //   } finally {
  //     setTableLoading(false);
  //     setHasFetchedOnce(true); // mark as fetched
  //   }
  // };
  
  // useEffect(() => {
  //   fetchGetAllTableData();
  // }, [oId,UserId]);




// -------------------------------------------
//           For SSC functions
// -------------------------------------------

const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};





// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!sscSelectedClass || !sscSelectedSection || !UserId) {
    setFilteredData([]);
    // setOriginalData([]);
    setTableLoading(false);
    return;
  }
  setTableLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/feePayment/adm/getAllfeePayments/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&rolePayment=additional_fee`
    );
    const data = await response.json();
    if (response.ok) {
      // setOriginalData(data);
      setFilteredData(data.feePayments || []);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      // setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setTableLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType(data[0] || "");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----

const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    setInterSelectedSection("");
    return;
  }

  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections || "";
      const sections = sectionsString
        .split(",")
        .map((section) => section.trim());

      setInterSectionOptions(sections);
      setInterSelectedSection(sections[0] || "");
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE section data:", error);
    setInterSectionOptions([]);
    setInterSelectedSection("");
  }
};






// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    // setOriginalData([]);
    setTableLoading(false);
    return;
  }
  setTableLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/feePayment/adm/getAllfeePayments/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&rolePayment=additional_fee`
      
    );
    const data = await response.json();
    if (response.ok) {
      // setOriginalData(data);
      setFilteredData(data.feePayments || []);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      // setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
    setFilteredData([]);
  } finally {
    setTableLoading(false);
  }
};




useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchSectionsData();
  } else if (board === "SSC") {
    fetchClassRegistrationData();
  }
}, [board, interSelectedClass, selectedCourseType, oId]);

// SSC: When selected class changes, update its sections
// useEffect(() => {
//   const updateSectionOptions = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
//       const data = await response.json();
//       if (response.ok && Array.isArray(data)) {
//         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
//         if (selectedClassData) {
//           const sections = selectedClassData.sections.split(",");
//           setSscSectionOptions(sections);
//           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
//         } else {
//           setSscSectionOptions([]);
//           setSscSelectedSection("");
//         }
//       }
//     } catch (error) {
//       console.error("Error updating SSC sections:", error);
//     }
//   };

//   if (board === "SSC" && sscSelectedClass) {
//     updateSectionOptions();
//   }
// }, [sscSelectedClass, board, oId]);

// INTERMEDIATE: When class or course type changes, update sections
useEffect(() => {
  const updateIntermediateSections = async () => {
    if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
      await fetchSectionsData();
    }
  };
  updateIntermediateSections();
}, [interSelectedClass, selectedCourseType, board]);



// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection) {
      setFilteredData([]);
      setTableLoading(false); // ✅ stop loading even if API not called
      return;
    }
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
      setFilteredData([]);
      setTableLoading(false); // ✅ same here
      return;
    }
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [UserId,board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);

// useEffect(() => {
//   const fetchData = () => {
//     if (board === "SSC") {
//       if (sscSelectedClass && sscSelectedSection && mode === "classSection") {
//         fetchClassSectionTableData();
//       } else {
//         setFilteredData([]);
//         setTableLoading(false);
//       }
//     } else if (board === "INTERMEDIATE") {
//       if (selectedCourseType && interSelectedClass && interSelectedSection && mode === "classSection") {
//         fetchCourseClassSectionTableData();
//       } else {
//         setFilteredData([]);
//         setTableLoading(false);
//       }
//     }
//   };

//   fetchData();
// }, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection, mode]);







    // Filter data based on searchQuery
    const filteredResults = filteredData.filter((item) => {
      // const studentSurname = item.surName ? item.surName.toLowerCase() : "";
      const studentFirstName = item.firstName ? item.firstName.toLowerCase() : "";
      const studentLastName = item.lastName ? item.lastName.toLowerCase() : "";
      const fullName =
        `${studentFirstName} ${studentLastName}`.trim(); // Combine first and last names
      const admissionNumber = item.customAdmissionNumber
        ? item.customAdmissionNumber.toString()
        : ""; // Ensure it's a string
  
      return (
        fullName.includes(searchQuery.toLowerCase()) || // Search in full name
        admissionNumber.includes(searchQuery) // Search in admission number
      );
    });


 
  const handleEdit = (field, value) => {
    setEditedData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    // Validate required fields
    let newErrors = {};

    if (!editedData.paymentDate)
      newErrors.paymentDate = "Payment Date is required";
    // if (!editedData.transactionId)
    //   newErrors.transactionId = "Transaction ID is required";
    if (!editedData.paymentAmount)
      newErrors.paymentAmount = "Amount to be Paid is required";
    if (!editedData.payMethod)
      newErrors.payMethod = "Payment Method is required";

    // If there are errors, set them and return early
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    const UserId = userId || selectedUsers;
    try {
      // Prepare FormData
      const formData = new FormData();
      Object.entries(editedData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // Ensure sblId is explicitly sent as null (if required)
      formData.append("sblId", "0");

      // API request
      const response = await fetch(
        `${baseUrl}/api/transaction/save/${selectedStudentId}/${UserId}/admission_fee/${editedData.romanNumberClass}/${editedData.sections}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const errorText = await response.text(); // Get detailed error response
        throw new Error(`${errorText}`);
      }

      // Success response
      toast.success("Payment saved successfully!", { autoClose: 1000 });

      // fetchGetAllTableData();
      
      if(board === "INTERMEDIATE") {
        fetchCourseClassSectionTableData();
      }else{
        fetchClassSectionTableData();
      }
      handleCloseDialog();
      setErrors({}); // Clear errors on successful submission
    } catch (error) {
      console.error("Error saving payment:", error);
      toast.error(`${error.message}`, {
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];
  const handleViewClick = (row) => {
    setSelectedRowData(row);
    setSelectedStudentId(row.studentId);
    setEditedData({
      grandTotal: row.grandTotal || "",
      totalPaid: row.totalPaid || "",
      feeDue: row.feeDue || "",
      payMethod: "Cash", // Default value
      paymentDate: today, // Default empty
      transactionId: "",
      fathersName: row.fathersName || "",
      firstName: row.firstName || "",
      lastName: row.lastName || "",
      romanNumberClass: row.romanNumberClass || "",
      sections: row.sections || "",
    });
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };






  

  // Export to Excel
//   const exportToExcel = () => {
//     const isIntermediate = board === "INTERMEDIATE";
//     const dynamicKey = isIntermediate ? "Year" : "Class";

//     const filteredData = filteredResults.map(
//       ({
//         customAdmissionNumber,
//         course,
//         romanNumberClass,
//         sections,
//         // surName,
//         firstName,
//         lastName,
//         gender,
//         fathersName,
//         primaryContact,
//         grandTotal,
//         totalPaid,
//         feeDue,
//       }) => ({
//         AdmissionNumber: customAdmissionNumber,
//         ...(isIntermediate ? { Course: course } : {}),
//       [dynamicKey]: romanNumberClass,
//         Section: sections,
//         StudentName: `${firstName} ${lastName}`,
//         Gender: gender,
//         FatherName: fathersName,
//         Phone: primaryContact,
//         TotalFee: grandTotal,
//         PaidAmount: totalPaid,
//         DueAmount: feeDue,
//       })
//     );

//     const workbook = new ExcelJS.Workbook();
   
//     // const worksheet = workbook.addWorksheet(
//     //   board === "INTERMEDIATE"
//     //   ? `${interSelectedClass}-${interSelectedSection}_SchoolFeeList`
//     //   : `${sscSelectedClass}-${sscSelectedSection}_SchoolFeeList`
//     // );

//     const worksheet = workbook.addWorksheet(
//   (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
//     ? `${interSelectedClass}-${interSelectedSection}_SchoolFeeList`
//     : (board === "SSC" && sscSelectedClass && sscSelectedSection)
//     ? `${sscSelectedClass}-${sscSelectedSection}_SchoolFeeList`
//     : "SchoolFeeList"
// );

//     // Add headers
//     worksheet.columns = [
//       { header: "Admission No", key: "AdmissionNumber", width: 15 },
//       ...(board === "INTERMEDIATE"
//         ? [{ header: "Course", key: "Course", width: 15 }]
//         : []),
//       { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
//       { header: "Section", key: "Section", width: 10 },
//       { header: "Student Name", key: "StudentName", width: 25 },
//       { header: "Gender", key: "Gender", width: 10 },
//       { header: "Father Name", key: "FatherName", width: 20 },
//       { header: "Phone", key: "Phone", width: 15 },
//       { header: "Total Fee", key: "TotalFee", width: 15 },
//       { header: "Paid Amount", key: "PaidAmount", width: 15 },
//       { header: "Due Amount", key: "DueAmount", width: 15 },
//     ];

//     filteredData.forEach((data) => {
//       const row = worksheet.addRow(data);
//       const paidCell = row.getCell("PaidAmount");
//       const dueCell = row.getCell("DueAmount");

//       // Apply green text color for Paid Amount
//       paidCell.font = { color: { argb: "008000" }, bold: true }; // Green & Bold

//       // Apply red text color for Due Amount
//       if (data.DueAmount > 0) {
//         dueCell.font = { color: { argb: "FF0000" }, bold: true }; // Red & Bold
//       }
//     });

//     // Style headers
//     worksheet.getRow(1).eachCell((cell) => {
//       cell.font = { bold: true };
//       cell.alignment = { horizontal: "center" };
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "87CEEB" }, // Light Blue Header
//       };
//     });

//     // Write and download file
//     workbook.xlsx.writeBuffer().then((buffer) => {
//       const blob = new Blob([buffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);


//     //   link.download = board === "INTERMEDIATE"
//     //   ? `${interSelectedClass}-${interSelectedSection}_SchoolFeeList.xlsx`
//     //   : `${sscSelectedClass}-${sscSelectedSection}_SchoolFeeList.xlsx`;
//     //   link.click();
//     // });


//     link.download = 
//   (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
//     ? `${interSelectedClass}-${interSelectedSection}_SchoolFeeList.xlsx`
//     : (board === "SSC" && sscSelectedClass && sscSelectedSection)
//     ? `${sscSelectedClass}-${sscSelectedSection}_SchoolFeeList.xlsx`
//     : "SchoolFeeList.xlsx";


//       link.click();
//     });

//     handleExportClose();
//   };

const exportToExcel = () => {
  const isIntermediate = board === "INTERMEDIATE";
  const dynamicKey = isIntermediate ? "Year" : "Class";

  const filteredData = filteredResults.map(
    ({
      customAdmissionNumber,
      course,
      romanNumberClass,
      sections,
      firstName,
      lastName,
      gender,
      fathersName,
      primaryContact,
      grandTotal,
      totalPaid,
      feeDue,
    }) => ({
      AdmissionNumber: customAdmissionNumber || "NA",
      ...(isIntermediate ? { Course: course || "NA" } : {}),
      [dynamicKey]: romanNumberClass || "NA",
      Section: sections || "NA",
      StudentName: `${firstName || ""} ${lastName || ""}`.trim(),
      Gender: gender || "NA",
      FatherName: fathersName || "NA",
      Phone: primaryContact || "NA",
      TotalFee: grandTotal || 0,
      PaidAmount: totalPaid || 0,
      DueAmount: feeDue || 0,
    })
  );

  const workbook = new ExcelJS.Workbook();

  const worksheet = workbook.addWorksheet(
    (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
      ? `${interSelectedClass}-${interSelectedSection}_AdditionalFeeList`
      : (board === "SSC" && sscSelectedClass && sscSelectedSection)
      ? `${sscSelectedClass}-${sscSelectedSection}_AdditionalFeeList`
      : "_AdditionalFeeList"
  );

  // Define columns
  worksheet.columns = [
    { header: "Admission No", key: "AdmissionNumber", width: 15 },
    ...(isIntermediate ? [{ header: "Course", key: "Course", width: 15 }] : []),
    { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
    { header: "Section", key: "Section", width: 10 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Gender", key: "Gender", width: 10 },
    { header: "Father Name", key: "FatherName", width: 20 },
    { header: "Phone", key: "Phone", width: 15 },
    { header: "Total Fee", key: "TotalFee", width: 15 },
    { header: "Paid Amount", key: "PaidAmount", width: 15 },
    { header: "Due Amount", key: "DueAmount", width: 15 },
  ];

  // Add data rows
  filteredData.forEach((data) => {
    const row = worksheet.addRow(data);
    const paidCell = row.getCell("PaidAmount");
    const dueCell = row.getCell("DueAmount");

    paidCell.font = { color: { argb: "008000" }, bold: true }; // Green bold
    if (data.DueAmount > 0) {
      dueCell.font = { color: { argb: "FF0000" }, bold: true }; // Red bold
    }
  });

  // Header styling
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light Blue
    };
  });

  // Totals
  const totalFee = filteredData.reduce((sum, d) => sum + (d.TotalFee || 0), 0);
  const totalPaid = filteredData.reduce((sum, d) => sum + (d.PaidAmount || 0), 0);
  const totalDue = filteredData.reduce((sum, d) => sum + (d.DueAmount || 0), 0);

  const totalRow = worksheet.addRow({
    AdmissionNumber: "Total Amount",
    TotalFee: `₹${totalFee.toLocaleString("en-IN")}`,
    PaidAmount: `₹${totalPaid.toLocaleString("en-IN")}`,
    DueAmount: `₹${totalDue.toLocaleString("en-IN")}`,
  });

  // Merge cells before TotalFee
  const mergeEnd = isIntermediate ? "H" : "G";
  worksheet.mergeCells(`A${totalRow.number}:${mergeEnd}${totalRow.number}`);

  // Style total row
  totalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFF9C4" }, // Light Yellow
    };
  });

  // Download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = 
      (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
        ? `${interSelectedClass}-${interSelectedSection}_AdditionalFeeList.xlsx`
        : (board === "SSC" && sscSelectedClass && sscSelectedSection)
        ? `${sscSelectedClass}-${sscSelectedSection}_AdditionalFeeList.xlsx`
        : "_AdditionalFeeList.xlsx";
    link.click();
  });

  handleExportClose();
};

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
    const isIntermediate = board === "INTERMEDIATE";
  
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
  
    // const title = isIntermediate
    //   ? `${interSelectedClass}-${interSelectedSection} School Fee List`
    //   : `${sscSelectedClass}-${sscSelectedSection} School Fee List`;

       if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.text(`${interSelectedClass}-${interSelectedSection} Additional Fee List`, 10, 8);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.text(`${sscSelectedClass}-${sscSelectedSection} Additional Fee List`, 10, 8);
} else {
  doc.text(`Additional Fee List`, 10, 8);
}
  
    // doc.text(title, 10, 8);
  
    // Generated On
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Generated On: ", 14, 16);
    doc.setFont("helvetica", "bold");
    doc.text(new Date().toLocaleDateString(), 40, 16);
  
    // Headers with dynamic "Year"/"Class"
    const headers = [
      "S.No",
      "Admission No",
      isIntermediate ? "Year" : "Class",
      "Section",
      "Student Name",
      "Father Name",
      "Phone",
      "Total Fee",
      "Paid Amount",
      "Due Amount",
    ];
  
    // Body data
    const body = filteredResults.map((row, index) => [
      index + 1,
      row.customAdmissionNumber,
      `${row.romanNumberClass}`,
      row.sections,
      `${row.firstName} ${row.lastName}`,
      row.fathersName,
      row.primaryContact,
      row.grandTotal,
      {
        content: row.totalPaid,
        styles: { textColor: [0, 128, 0], fontStyle: "bold" }, // Green
      },
      {
        content: row.feeDue,
        styles: { textColor: [255, 0, 0], fontStyle: "bold" }, // Red
      },
    ]);
  
    // Table rendering
    doc.autoTable({
      startY: 20,
      head: [headers],
      body,
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181],
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });
  
    // Save file
    // const fileName = isIntermediate
    //   ? `${interSelectedClass}-${interSelectedSection}_SchoolFeeList.pdf`
    //   : `${sscSelectedClass}-${sscSelectedSection}_SchoolFeeList.pdf`;

      if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.save(`${interSelectedClass}-${interSelectedSection}_AdditionalFeeList.pdf`);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.save(`${sscSelectedClass}-${sscSelectedSection}_AdditionalFeeList.pdf`);
} else {
  doc.save(`AdditionalFeeList.pdf`);
}
  
    // doc.save(fileName);
    handleExportClose();
  };
  

  // Export to JSON
 

  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredResults, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    // if(board === "INTERMEDIATE") {
    //   link.download = `${interSelectedClass}-${interSelectedSection}_SchoolFeeList.json`;
    // } else {
    //   link.download = `${sscSelectedClass}_${sscSelectedSection}_SchoolFeeList.json`;
    // }
    if (
  board === "INTERMEDIATE" &&
  interSelectedClass &&
  interSelectedSection
) {
  link.download = `${interSelectedClass}-${interSelectedSection}_AdditionalFeeList.json`;
} else if (
  board === "SSC" &&
  sscSelectedClass &&
  sscSelectedSection
) {
  link.download = `${sscSelectedClass}_${sscSelectedSection}_AdditionalFeeList.json`;
} else {
  link.download = `AdditionalFeeList.json`;
}

    link.click();
    handleExportClose();
  };

  return (
<Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      style={{
        // margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        width: "100%",
        // maxHeight: "100vh",
        // overflow: "hidden",
      }}
    >
      <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 2 }}>
        {/* Title Section */}
        <Box display="flex" alignItems="center">
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
            Additional Fee List
          </Typography>
        </Box>

        {/* Right side */}
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpen(true)}
                  sx={{
                    backgroundColor: "#3C3972",
                    color: "#fff",
                    fontWeight: "bold",
                    px: 2,
                    py: 1,
                  //   borderRadius: 2,
                    "&:hover": {
                      backgroundColor: "#3C3972",
                    }
                  }}
                >
                  Assign Admission Fee
                </Button> */}
                </Box>

        {/* Search and Add New Button Section */}
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ marginTop: "1px" }}
        >
          {/* Left Side - Search & Select */}
          <Grid
            item
            xs={9}
            style={{ display: "flex", gap: "5px", alignItems: "center" }}
          >
            <TextField
              label="Search by Admission No or Name"
              variant="outlined"
              size="small"
              style={{ width: "220px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              fullWidth
            />

           {board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
       

        onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          setMode("classSection");
      
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
        
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>
{/* 
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="section-select-label">Select Section</InputLabel>
      <Select
        labelId="section-select-label"
        value={sscSelectedSection}
        // onChange={(e) => setSscSelectedSection(e.target.value)}
        onChange={(e) => {
          setSscSelectedSection(e.target.value);
          setMode("classSection");
        }}
        
        label="Select Section"
        sx={{ height: 35 }}
        // disabled={sscSectionOptions.length === 0}
      >
        
        {sscSectionOptions.map((section) => (
          <MenuItem key={section} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl> */}
    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
  <InputLabel id="section-select-label">Select Section</InputLabel>
  <Select
    labelId="section-select-label"
    value={sscSelectedSection}
    onChange={(e) => {
      setSscSelectedSection(e.target.value);
      setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {/* Show placeholder if no sections */}
    {sscSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Class
      </MenuItem>
    ) : (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        // onChange={(e) => setSelectedCourseType(e.target.value)}
        onChange={(e) => {
          setSelectedCourseType(e.target.value);
          setMode("classSection");
        }}
        
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

   
    <FormControl size="small" sx={{ minWidth: 120 }}>
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    value={interSelectedSection || ""}
    onChange={(e) => {
      setInterSelectedSection(e.target.value);
      setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {interSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Year and Course
      </MenuItem>
    ) : (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)}

 {/* <Button
  onClick={() => {
    if (board === "SSC") {
      setSscSelectedClass('');
      setSscSelectedSection('');
    } else if (board === "INTERMEDIATE") {
      setInterSelectedClass('');
      setSelectedCourseType('');
      setInterSelectedSection('');
    }

    setMode("scrolling");
    // fetchGetAllTableData();
  }}
  variant="outlined"
  color="primary"
  
  // sx={{marginLeft:'10px',width:'170px',height:'35px'}}
   sx={{
    marginLeft: '10px',
    width: '220px',           // increased width to fit text
    height: '35px',
    whiteSpace: 'nowrap',     // prevent text from wrapping
    textTransform: 'none',    // keep original case
    fontWeight: 'bold',       // optional styling
  }}
>
  Fetch OverAll Data
</Button>  */}

 {/* Dropdown at Right End */}
             {/* {isPrincipal && (
                      <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
                        <InputLabel>Select Admin</InputLabel>
                        <Select
                          value={selectedUsers}
                          onChange={(e) => setSelectedUsers(e.target.value)}
                          label="Select Admin"
                        >
                          {users.map((user) => (
                            <MenuItem key={user.userId} value={user.userId}>
                              {user.userId}-{user.firstName} {user.lastName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )} */}



          </Grid>
          {/* Right Side - Button */}

          <Grid
            item
            xs={3}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              onClick={handleExportClick}
              style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
              startIcon={<PresentToAllIcon />}
            >
              Export
            </Button>

            <Menu
              anchorEl={exportAnchorEl}
              open={isExportMenuOpen}
              onClose={handleExportClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                },
              }}
            >
              <MenuItem
                onClick={exportToExcel}
                sx={{
                  color: "#3f51b5",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#e8f0fe",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#00796b" }}>
                  <SimCardDownloadIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Excel"
                  sx={{ fontWeight: "bold", color: "#00796b" }}
                />
              </MenuItem>

              <MenuItem
                onClick={exportToPDF}
                sx={{
                  color: "#d32f2f",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#fdecea",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#d32f2f" }}>
                  <PictureAsPdfIcon />
                </ListItemIcon>
                <ListItemText
                  primary="PDF"
                  sx={{ fontWeight: "bold", color: "#d32f2f" }}
                />
              </MenuItem>

              <MenuItem
                onClick={exportToJSON}
                sx={{
                  color: "#388e3c",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#e8f5e9",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#6a1b9a" }}>
                  <FilePresentIcon />
                </ListItemIcon>
                <ListItemText
                  primary="JSON"
                  sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                />
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "800px",
            overflow: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Admission No
                </TableCell> */}
                {(board === "INTERMEDIATE" ) && (
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ddd",
                                        padding: "4px",
                                        backgroundColor: "#fff9c4",
                                        textAlign: "center",
                                        fontWeight: "Bold",
                                      }}
                                    >
                                      Course
                                    </TableCell>
                                    )}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  {board === "INTERMEDIATE" ? "Year" : "Class"}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Section
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "2px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Gender
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Father Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Amount
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "2px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Paid Amount
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Due Amount
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Action
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Transactions
                </TableCell> */}
                

                {/* <TableCell sx={{ padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Action</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
               {
              //  !hasFetchedOnce || 
               tableLoading ? ( 
              
                <TableRow>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Loading Data...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={13} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "40px", // Reduced row height
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.customAdmissionNumber}
                    </TableCell> */}
                    {board === "INTERMEDIATE" && (
                                            <TableCell
                                              sx={{
                                                borderRight: "1px solid #ddd",
                                                padding: "4px",
                                                textAlign: "center",
                                              }}
                                            >
                                              {row.course}
                                            </TableCell>
                                            )}


                    <TableCell
                      sx={{
                        borderRight: "1px solid #ddd",
                        padding: "3px",
                        textAlign: "center",
                      }}
                    >
                      {["NURSERY", "LKG", "UKG"].includes(
                        row.romanNumberClass?.toString().trim()
                      )
                        ? row.romanNumberClass
                        : `${row.romanNumberClass}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.sections}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.firstName} {row.lastName}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.gender || "N/A"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.fathersName || "N/A"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.primaryContact || "No Number"}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                        fontWeight: "bold",
                      }}
                    >
                      ₹{row.grandTotal}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "1px solid #ddd",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        style={{
                          backgroundColor: "#65C63E",
                          color: "#fff",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "20px",
                        }}
                      >
                        ₹{row.totalPaid}{" "}
                        {/* Paid amount displayed as light green button */}
                      </Button>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderRight: "1px solid #ddd",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        style={{
                          backgroundColor: "#ED3638",
                          color: "#fff",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "20px",
                        }}
                      >
                        ₹{row.feeDue}{" "}
                        {/* Unpaid amount displayed as red outlined button */}
                      </Button>
                    </TableCell>

                    <TableCell
                      sx={{
                        borderRight: "1px solid #ddd",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                     
                      <Button
                              type="button"
                              // onClick={() => handleViewClick(row)} // Open dialog with the row data
                              onClick={() => navigate(`/IndividualStudentsBooksList/${row.romanNumberClass}/${row.studentId}/${row.firstName}_${row.lastName}`)} // Open dialog with the row data
                              // disabled={row.feeDue === 0} // ✅ Disable when feeDue is 0
                              sx={{
                                backgroundColor: row.feeDue === 0 ? "#65C63E" : "#1976d2", // Gray background when disabled
                                color: "white",
                                fontSize: "0.7rem",
                                height: "25px",
                                "&:hover": {
                                  backgroundColor: row.feeDue === 0 ? "#65C63E" : "#1565c0",
                                },
                              }}
                            >
                              Additional Fee
                            </Button>
                    </TableCell>
                     {/* <TableCell
                      sx={{
                        borderRight: "1px solid #ddd",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                     
                      <Button
                              type="button" 
                              onClick={() => navigate(`/StudentPaymentsTransactionList/${row.admissionNumber}/${row.rolePayment}`)} // Open dialog with the row data
                              disabled={row.totalPaid === 0} // ✅ Disable when feeDue is 0
                              sx={{
                                backgroundColor: row.totalPaid === 0 ? "#ccc" : "#1976d2", // Gray background when disabled
                                color: "white",
                                fontSize: "0.7rem",
                                height: "25px",
                                "&:hover": {
                                  backgroundColor: row.totalPaid === 0 ? "#ccc" : "#1565c0",
                                },
                              }}
                            >
                              View
                            </Button>
                    </TableCell> */}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog Box */}
        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="sm"
          sx={{ borderRadius: 3 }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              bgcolor: "#1976d2",
              color: "white",
              py: 2,
              borderTopLeftRadius: 3,
              borderTopRightRadius: 3,
            }}
          >
            Admission Fee Payment
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: "20px",
              }}
            >
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ display: "flex", width: "100%" }}>
                  <span style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    Student Name:
                  </span>
                  <span>
                    {editedData.surName} {editedData.firstName}{" "}
                    {editedData.lastName}
                  </span>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                  <span style={{ fontWeight: "bold", paddingRight: "15px" }}>
                    Father Name:
                  </span>
                  <span>{editedData.fathersName}</span>
                </div>
              </div>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label="Total Fee"
                    variant="outlined"
                    value={`₹${editedData.grandTotal}`}
                    fullWidth
                    size="small"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Paid Amount"
                    variant="outlined"
                    value={`₹${editedData.totalPaid || "No Paid Amount"}`}
                    fullWidth
                    size="small"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>
              {/* </Grid> */}
              {/* <Grid container spacing={2}> */}
                <Grid item xs={6}>
                  <TextField
                    label="Due Amount"
                    variant="outlined"
                    value={`₹${editedData.feeDue || "No Fee Due Amount"}`}
                    fullWidth
                    size="small"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>

               
              {/* <Grid item xs={6}>
                <TextField
                  label="Payment Date"
                  variant="outlined"
                  type="date"
                  value={editedData.paymentDate}
                  onChange={(e) => {
                    handleEdit("paymentDate", e.target.value);
                    setErrors({ ...errors, paymentDate: "" });
                  }}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={!!errors.paymentDate}
                  helperText={errors.paymentDate}
                  inputProps={{
                    min: new Date().toISOString().split("T")[0],
                    max: new Date().toISOString().split("T")[0],
                  }}
                />
              </Grid> */}
              <Grid item xs={6}>
                <TextField
                  label="Payment Date"
                  variant="outlined"
                  type="date"
                  value={editedData.paymentDate }
                  onChange={(e) =>
                    handleEdit("paymentDate", e.target.value)
                  }
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0], // ✅ No future dates
                  }}
                />
              </Grid>
              

                <Grid item xs={6}>
                  <TextField
                    label="Amount to be Paid"
                    variant="outlined"
                    type="number"
                    value={editedData.paymentAmount}
                    onChange={(e) => {
                      handleEdit("paymentAmount", e.target.value);
                      setErrors({ ...errors, paymentAmount: "" });
                    }}
                    fullWidth
                    size="small"
                    error={!!errors.paymentAmount}
                    helperText={errors.paymentAmount}
                  />
                </Grid>
              {/* </Grid>
              <Grid container spacing={2}> */}
                {/* <Grid item xs={6}>                                                                
          <TextField label="Payment Date" variant="outlined" type="date" value={editedData.paymentDate} onChange={(e) => handleEdit("paymentDate", e.target.value)} fullWidth size="small" InputLabelProps={{ shrink: true }} />
        </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    label="Transaction Id"
                    variant="outlined"
                    value={editedData.transactionId}
                    onChange={(e) => {
                      handleEdit("transactionId", e.target.value);
                    //   setErrors({ ...errors, transactionId: "" });
                    }}
                    fullWidth
                    size="small"
                    // error={!!errors.transactionId}
                    // helperText={errors.transactionId}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.payMethod}
                  >
                    <InputLabel>Payment Method</InputLabel>
                    <Select
                      value={editedData.payMethod}
                      onChange={(e) => {
                        handleEdit("payMethod", e.target.value);
                        setErrors({ ...errors, payMethod: "" });
                      }}
                      label="Payment Method"
                    >
                      <MenuItem value="Cash">Cash</MenuItem>
                      <MenuItem value="Credit">Credit Card</MenuItem>
                      <MenuItem value="Debit">Debit</MenuItem>
                      <MenuItem value="Online">Online</MenuItem>
                    </Select>
                    {errors.payMethod && (
                      <FormHelperText>{errors.payMethod}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

              </Grid>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{ justifyContent: "flex-end", pt: 0.5, pb: 1, pr: 2 }}
          >
            <Button
              onClick={handleCloseDialog}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              color="success"
              variant="outlined"
              sx={{
                backgroundColor: "#3C3972",
                color: "white",
                fontSize: "0.8rem",
                height: "35px",
                minWidth: "80px", // Ensures consistent button size
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  backgroundColor: "#3C3972",
                },
              }}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <CircularProgress size={20} sx={{ color: "white" }} />
              ) : (
                "Save"
              )}
            </Button>
          </DialogActions>
        </Dialog>


              {/* tution FEE Amount Dialog Box */}
        {/* <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <Typography variant="h5" sx={{fontWeight:'bold'}}>Assign Admission Fee</Typography>
                  
                  <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                      position: "absolute",
                      right: 12,
                      top: 12,
                      color: (theme) => theme.palette.grey[500]
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
        
                <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        
                  {board === "SSC" && (
          <>
                  <FormControl fullWidth>
                    <InputLabel>Select Class</InputLabel>
                    <Select
                      value={romanNumberClass}
                      label="Select Class"
                      onChange={(e) => setRomanNumberClass(e.target.value)}
                    >
                       <MenuItem value="All">Assign All Classes</MenuItem>
                      {sscClassOptions.map((cls) => (
                  <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                ))}
                    </Select>
                  </FormControl>
                  
          </>
        )}
        
        
        {board === "INTERMEDIATE" && (
          <>
           <FormControl fullWidth>
                    <InputLabel>Select Class</InputLabel>
                    <Select
                      value={romanNumberClass}
                      label="Select Class"
                      onChange={(e) => setRomanNumberClass(e.target.value)}
                    >
                        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                    </Select>
                  </FormControl>
        
        
                      <FormControl fullWidth size="medium">
          <InputLabel id="course-type-label">Select Course*</InputLabel>
          <Select
            labelId="course-type-label"
            value={dialogcourse}
            onChange={(e) => setDialogCourse(e.target.value)}
            label="Select Course*"
          >
            {courseOptions.length > 0 ? (
              courseOptions.map((course, index) => (
                <MenuItem key={index} value={course}>
                  {course}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No courses available</MenuItem>
            )}
          </Select>
        </FormControl>
           </>
        )}
        
                  <TextField
                    label="Tuition Fee Amount"
                    fullWidth
                    type="number"
                    value={examFee}
                    onChange={(e) => {
                      const val = e.target.value;
                     
                        setExamFee(val);
                     
                    }}
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </DialogContent>
        
                <DialogActions sx={{ padding: "1rem" }}>
                  <Button
                    onClick={handleSubmit}
                    disabled={examloading}
                    sx={{
                      background: "#3c3972",
                      color: "#fff",
                      fontWeight: "bold",
                      "&:hover": {
                        background: "#3c3972"
                      }
                    }}
                  >
                    {examloading ? <CircularProgress size={20} color="inherit" /> : "Submit"}
                  </Button>
                </DialogActions>
              </Dialog> */}
        

        <ToastContainer position="top-right" autoClose={1000} />
      </CardContent>
    </Card>
   </Box>
  );
}

export default BooksFeeList;